import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BankAccountMonthUI from '../../../components/superUser/transaction/BankAccountMonthUI'
import ClimeTransferModalSF from '../../../components/superUser/transaction/ClimeTransferModalSF'
import BankAccountMonthHeaderUI from '../../../components/superUser/transaction/BankAccountMonthHeaderUI'
import BankAccountAddModalSF from '../../../components/superUser/transaction/BankAccountAddModalSF'
import AddCollectionAccModalSF from '../../../components/superUser/transaction/AddCollectionAccModalSF.js'

const BankAccountPageUI = ({ context, account, bankAccountList, loanBankAccountNum,
  genBankAccountNum, bankAccountMonthList, onRefreshClick,
  createMode, onCreateClick,
  transferMode, onTransferClick, onCancelTransferClick, bankAccountNumber, onAddBankAccountClick,
  addBankAccountMode, onCancelAddBankAccount,
  addCollectionAccMode, onAddCollectionAccClick, onAddCollectionAccCancel
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_acc' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`}
    centered={!bankAccountList} topnav='accounts'
    account={account} bankAccountNumber={bankAccountNumber} page='bank'
  >
    {
      !bankAccountList &&
      <SpinnerComponentUI />
    }
    {
      bankAccountList && !bankAccountList.length &&
      <>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <IconButtonUI icon='icon-plus' onClick={onAddBankAccountClick} label='Add Traditional Escrow' />
              <span className='g_m_left_100 g_large'><b>Escrow Accounts</b></span>
            </span>
          }
          right={
            <span />
          }
        />

        <EmptyListUI context={context} createEnabled={false}
          createDisabledMessageLabel='No escrow accounts'
        />
      </>
    }
    {
      bankAccountList && bankAccountList.length > 0 &&
      <div>
        <BankAccountMonthHeaderUI context={context} account={account} bankAccountList={bankAccountList}
          bankAccountNumber={bankAccountNumber} onRefreshClick={onRefreshClick}
          onTransferClick={onTransferClick} onAddCollectionAccClick={onAddCollectionAccClick}
          loanBankAccountNum={loanBankAccountNum} genBankAccountNum={genBankAccountNum}
          onAddBankAccountClick={onAddBankAccountClick}
        />
        {
          bankAccountMonthList && bankAccountMonthList.length !== 0 &&
          <BankAccountMonthUI
            context={context}
            createMode={createMode}
            onCreateClick={onCreateClick}
            bankAccountMonthList={bankAccountMonthList}
            bankAccountNumber={bankAccountNumber}
          />
        }
      </div>
    }

    {
      loanBankAccountNum &&
      <ClimeTransferModalSF context={context}
        loanBankAccountNum={loanBankAccountNum}
        genBankAccountNum={genBankAccountNum}
        transferMode={transferMode}
        onCancelClick={onCancelTransferClick} onRefreshClick={onRefreshClick}
      />
    }
    <BankAccountAddModalSF context={context} addBankAccountMode={addBankAccountMode} onCancelAddBankAccount={onCancelAddBankAccount} account={account} />
    <AddCollectionAccModalSF context={context} account={account} createMode={addCollectionAccMode}
      onCancelClick={onAddCollectionAccCancel} onRefreshClick={onRefreshClick} />
  </SuperUserAccountPageUI>


export default BankAccountPageUI
